import { render, staticRenderFns } from "./ImportGoal.vue?vue&type=template&id=80975e74"
import script from "./ImportGoal.vue?vue&type=script&lang=js"
export * from "./ImportGoal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports